import { decorateClass, isDecoratorArgs } from 'decorator-setup';

import { decode, encode } from 'rise-ui/utils/query-params.js';
import Route from 'rise-ui/utils/routing/route.js';

/**
 * Component class decorator to serialize/deserialize complex query-params.
 * @decorator
 */
export function complexQueryParams() {
  function classDecorator(Target) {
    if (!Route.isPrototypeOf(Target)) {
      throw new Error(
        '@complexQueryParams decorator should be applied to an Ember Route derived class',
      );
    }
    return decorateClass(class ComplexQueryParamsDecoratedRoute extends Target {
      serializeQueryParam(value, urlKey, defaultValueType) {
        const params = this.queryParams;
        let result;
        if (params[urlKey] && params[urlKey].complex) {
          result = value && encode(value);
        } else {
          result = super.serializeQueryParam(...arguments);
        }
        return result;
      }
      deserializeQueryParam(value, urlKey, defaultValueType) {
        const params = this.queryParams;
        let result;
        if (params[urlKey] && params[urlKey].complex) {
          result = value && decode(value);
        } else {
          result = super.deserializeQueryParam(...arguments);
        }
        return result;
      }
    });
  }
  return isDecoratorArgs(...arguments) ? classDecorator(...arguments) : classDecorator;
}
